// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submittingSolutionMessageContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 14px;
  padding: 0 32px calc(env(safe-area-inset-bottom, 0px) + 40px);
}

.submittingSolutionMessage {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.2;
}

.submittingSolutionSubMessage {
  color: var(--palette-text-muted);
  font-size: 0.95rem;
  max-width: 320px;
}

.goHomeButton,
.tryAgainButton {
  margin-top: 8px;
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 1rem;
  border: 0;
  border-radius: var(--r-btn);
  padding: 14px 28px;
  cursor: pointer;
  background: var(--palette-primary);
  color: var(--palette-on-primary);
}

.submittingButtonText {
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/submittingSolutionScreen.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".submittingSolutionMessageContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 14px;\n  padding: 0 32px calc(env(safe-area-inset-bottom, 0px) + 40px);\n}\n\n.submittingSolutionMessage {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 1.2;\n}\n\n.submittingSolutionSubMessage {\n  color: var(--palette-text-muted);\n  font-size: 0.95rem;\n  max-width: 320px;\n}\n\n.goHomeButton,\n.tryAgainButton {\n  margin-top: 8px;\n  font-family: var(--font-ui);\n  font-weight: 600;\n  font-size: 1rem;\n  border: 0;\n  border-radius: var(--r-btn);\n  padding: 14px 28px;\n  cursor: pointer;\n  background: var(--palette-primary);\n  color: var(--palette-on-primary);\n}\n\n.submittingButtonText {\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
